import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useQuery } from 'react-query';

function useUser(data = {}) {
  const { enabled = false, queryParams = '', userID } = data;
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;

  async function getUserDetails() {
    return privateFetch.get(`/v1/admin/user/${userID}${queryParams}`).then((res) => res.data);
  }

  return useQuery(['user-details', userID, { data }], getUserDetails, { enabled });
}

export default useUser;
